import { Label } from "@/components/ui/label";
import { SearchableDropdown } from "@/components/work-orders/SearchableDropdown";

// "Add from Equipment Library" picker above the WO line items.
// Combines the master library (scopes + equipment + parts) into a
// single SearchableDropdown; selecting an item appends a new line
// row via the parent's `onAdd(item)` callback. Only renders in
// edit mode (`isEditable`). Extracted from WorkOrderTab.jsx
// (Feb 2026, iter182).
export function WOEquipmentLibraryPicker({ isEditable, items, onAdd }) {
  if (!isEditable) return null;
  return (
    <div className="bg-slate-50 rounded-lg p-3" data-testid="wo-equipment-library-picker">
      <Label className="text-xs font-semibold">Add from Equipment Library</Label>
      <p className="text-[10px] text-slate-400 mb-1.5">
        Search scopes, equipment &amp; parts to add as line items with pricing
      </p>
      <SearchableDropdown
        items={items}
        onChange={onAdd}
        placeholder="Search equipment library..."
      />
    </div>
  );
}
